import React from "react";
import { FaUsers,FaLightbulb,FaHandsHelping,FaChartLine, FaBalanceScale, FaHeart, FaGlobe } from "react-icons/fa";

const CoreValuesRadial = () => {
  const values = [
    { icon: <FaUsers />, title: "Diversity", color: "#00475d", text: "Strength in our diversity as a true South African entity." },
    { icon: <FaLightbulb />, title: "Enterprising", color: "#387688", text: "Forward thinking and innovative in our business solutions." },
    { icon: <FaHandsHelping />, title: "Teamwork", color: "#Aec9d8", text: "Recognising the support of others in building the future.Delivering service excellence." },
    { icon: <FaChartLine />, title: "Performance", color: "#Adb0b0", text: "Delivering service excellence." },
    { icon: <FaBalanceScale />, title: "Integrity", color: "#387688", text: "Our business conduct and credibility beyond reproach." },
    { icon: <FaHeart />, title: "Caring", color: "#Aec9d8", text: "Respect and caring for our employees." },
    { icon: <FaGlobe />, title: "Sustainability", color: "#adb0b0", text: "Acting responsibly and ensuring lasting continuance of all our well meant efforts " },
  ];

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    margin: "50px auto",
    maxWidth: "auto",
  };

  const circleStyle = {
    width: "220px",
    height: "220px",
    background: "#fff",
    borderRadius: "50%",
    marginLeft: "-30px", // overlap
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    textAlign: "center",
    padding: "30px 20px",
    zIndex: 1,
    transition: "transform 0.3s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const iconStyle = {
    fontSize: "2.5rem",
    // marginBottom: "10px",
  };

  const titleStyle = {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: "bold",
  };

  const textStyle = {
    fontSize: "14px",
    color: "#555",
  };

  return (
    <section className="governingStructure pb-0" id="governing-structure">
      <h1 className="section-title text-center pb-4">Core Values​</h1>
      <div style={containerStyle}>
        {values.map((val, index) => (
          <div
            key={index}
            style={{
              ...circleStyle,
              border: `4px solid ${val.color}`,
             
              marginLeft: index === 0 ? "0" : "-30px", // no overlap for first
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <div style={{ ...iconStyle, color: val.color }}>{val.icon}</div>
            <h3 style={{ ...titleStyle, color: val.color, height: "40px", }}>{val.title}</h3>
            <p style={textStyle}>{val.text}</p>
          </div>
        ))}
      </div>
    </section>


  );
};


export default CoreValuesRadial;